var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"padding":"0"}},[_c('iframe',{attrs:{"src":"http://monitor.cnzhonglunnet.com/dashboards/","width":"100%","height":_vm.pageHeight,"frameborder":"0"}})])}
var staticRenderFns = []

export { render, staticRenderFns }